import { MutationTree } from 'vuex';
import { MessagesState } from './types';

const mutations: MutationTree<MessagesState> = {
  setConnected(state: MessagesState, value: boolean) {
    state.isConnected = value;
  },
  setConnecting(state: MessagesState, value: boolean) {
    state.isConnecting = value;
  },
  setConnectionError(state: MessagesState, value: string | null) {
    state.connectionError = value;
  },
  setLastReceivedMessage(
    state: MessagesState,
    payload: { messageId: number | null; createdAt: number | null; channelUrl: string | null }
  ) {
    state.lastReceivedMessageId = payload.messageId;
    state.lastReceivedMessageAt = payload.createdAt;
    state.lastReceivedChannelUrl = payload.channelUrl;
  },

  setChannels(state: MessagesState, payload: { channels: any[]; rawChannels: any[] }) {
    state.channels = payload.channels;
    state.rawChannels = payload.rawChannels;
  },
  setLoadingChannels(state: MessagesState, loading: boolean) {
    state.loadingChannels = loading;
  },
  setChannelListError(state: MessagesState, error: string) {
    state.channelListError = error;
  },

  selectChannel(state: MessagesState, channelUrl: string) {
    state.currentChannelUrl = channelUrl;
  },

  setMessages(state: MessagesState, messages: any[]) {
    state.messages = messages;
  },
  addMessage(state: MessagesState, message: any) {
    state.messages = [...state.messages, message];
  },
  setLoadingMessages(state: MessagesState, loading: boolean) {
    state.loadingMessages = loading;
  },
  setMessageLoadError(state: MessagesState, error: string) {
    state.messageLoadError = error;
  },

  setSelectedUserInfo(state: MessagesState, payload: { otherUser: any; members: any[] }) {
    state.selectedOtherUser = payload.otherUser;
    state.selectedChannelMembers = payload.members;
  },

  setSending(state: MessagesState, sending: boolean) {
    state.sending = sending;
  },
  setSendError(state: MessagesState, error: string) {
    state.sendError = error;
  },

  setQueryParamChannelNotFound(state: MessagesState, value: boolean) {
    state.queryParamChannelNotFound = value;
  },

  clearChannelUnreadCount(state: MessagesState, channelUrl: string) {
    const channel = state.channels.find((ch: any) => ch.url === channelUrl);
    if (channel) {
      channel.unreadCount = 0;
    }
  },

  incrementChannelUnreadCount(state: MessagesState, channelUrl: string) {
    const channel = state.channels.find((ch: any) => ch.url === channelUrl);
    if (channel) {
      channel.unreadCount = (channel.unreadCount || 0) + 1;
    }
  },

  updateChannelPreviewAndSort(state: MessagesState, payload: { channelUrl: string; lastMessage: string; lastMessageAt: string }) {
    const index = state.channels.findIndex((ch: any) => ch.url === payload.channelUrl);
    if (index < 0) return;

    const existing = state.channels[index];
    const lastMessage = existing.otherUser?.bannerMessage || payload.lastMessage;
    const channel = { ...existing, lastMessage, lastMessageAt: payload.lastMessageAt };

    const updated = [...state.channels];
    updated.splice(index, 1);
    updated.unshift(channel);
    state.channels = updated;
  },

  replaceOptimisticMessage(state: MessagesState, payload: { optimisticId: string; message: any }) {
    const index = state.messages.findIndex((m: any) => m.id === payload.optimisticId);
    if (index >= 0) {
      state.messages = [...state.messages.slice(0, index), payload.message, ...state.messages.slice(index + 1)];
    } else {
      state.messages = [...state.messages, payload.message];
    }
  },

  removeOptimisticMessage(state: MessagesState, optimisticId: string) {
    state.messages = state.messages.filter((m: any) => m.id !== optimisticId);
  },
};

export default mutations;
